import React from 'react';
import { useTranslation } from 'react-i18next';
import KpiWidget from './KpiWidget';

const ResolveRateKpiWidget = ({
  resolveRate = null,
  resolvedCount = 0,
  sessionsWithStatus = 0
}) => {
  const { t } = useTranslation();

  const value = resolveRate != null ? `${resolveRate}%` : '-';
  const hint = sessionsWithStatus > 0
    ? t('dashboard.agent.resolveHint', { resolved: resolvedCount, total: sessionsWithStatus })
    : t('dashboard.agent.noResolutionData');

  const accent = resolveRate >= 70
    ? 'text-emerald-600'
    : resolveRate != null
      ? 'text-amber-600'
      : undefined;

  return (
    <KpiWidget
      label={t('dashboard.agent.resolveRate')}
      value={value}
      hint={hint}
      accent={accent}
    />
  );
};

export default ResolveRateKpiWidget;
